module.exports = __webpack_public_path__ + "img/0445_17.87d65357.jpg";